import { useQuery } from '@tanstack/react-query';
import { getCarFn } from '../../transactions/cars/car';
import CarCard from '../cars/carCard';
import { useNavigate } from 'react-router-dom';
import { NoDataFound } from '../elements/noDataFound';

export const LeasedCarsSection = () => {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryFn: () => getCarFn('', 1, 9),
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  if (data && !data.data?.length) {
    return (
      <div className="flex w-full max-lg:bg-[#F5F5F7] lg:bg-[#FFFFFF99] rounded-[12px] p-6 flex-col gap-[10px]">
        <div className="w-full flex flex-col gap-2">
          <h3>Μισθώσεις</h3>

          <NoDataFound title={'Δεν υπάρχουν μισθωμένα αυτοκίνητα.'}/>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full lg:bg-[#FFFFFF99] lg:rounded-[12px] lg:p-6 flex-col gap-[10px]">
      <div className="w-full flex justify-between items-center">
        <h3>Μισθώσεις</h3>
        <button onClick={() => navigate('/portal/my-cars')}>
          <h6 className="text-primary">Προβολή όλων</h6>
        </button>
      </div>
      <div className="grid lg:grid-cols-3 gap-[10px] max-lg:p-5  max-lg:rounded-[12px]  max-lg:bg-[#FFFFFF99]">
        {isLoading
          ? Array.from({ length: 9 }, (_, index) => (
              <div
                className={
                  'p-3 bg-white flex w-full items-center justify-between gap-3 rounded-lg'
                }
              >
                <div className="flex animate-pulse items-center justify-center gap-3">
                  <div className="rounded-full bg-powdergrey p-3 h-5 w-5 " />
                  <div className="flex flex-col gap-1">
                    <div className="w-20 h-5  bg-powdergrey  rounded-full" />
                    <div className="w-16 h-5 bg-powdergrey  rounded-full" />
                  </div>
                </div>
                <div className="w-20 h-5  bg-powdergrey rounded-full" />
              </div>
            ))
          : data &&
            data.data.slice(0, 9).map((car) => (
              <CarCard
                carData={{
                  isNewCar: car.isNewCar,
                  plateno: car.plateno,
                  title: car.MakeName,
                  subTitle: car.ModelName,
                  info: car.plateno,
                }}
                key={car.cncode}
              />
            ))}
      </div>
    </div>
  );
};
